import type { MarketplaceIdentifier } from "@opensea/graphql"
import { usePersona } from "@opensea/navigation"
import type { TokenPriceDisplayProps } from "@/components/price/TokenPrice"
import { useItemView } from "../ItemViewProvider"

export function useItemCardTokenPriceMarketplaceProps(
  marketplace: MarketplaceIdentifier | undefined,
): Partial<TokenPriceDisplayProps> {
  const { persona } = usePersona()
  const { itemView } = useItemView()

  if (!marketplace || persona === "collector") {
    return {}
  }

  return {
    marketplace,
    marketplaceIconSize: itemView === "gridCompact" ? 12.5 : 15,
    marketplaceIconSide: "right",
    marketplaceIconClassName: "fill-white",
  }
}
